import React from "react";

const SynthwaveHeading = ({ mainText = "UPSCALe", subText = "VIDEOS" }) => {
  const chromeGradient =
    "linear-gradient(180deg, #ffffff 0%, #d0d0d0 28%, #707070 48%, #d0d0d0 68%, #ffffff 100%)";

  return (
    <div className="flex flex-col items-center justify-center p-10">
      {/* Inject keyframes (small and local) */}
      <style>{`
        @keyframes ups-shine {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}</style>

      <h1
        // Keep Tailwind for layout/typography, but DON'T use bg-gradient-to-b or text-shadow bracket utilities
        className="font-rocket text-9xl font-bold tracking-widest mb-[-40px]"
        style={{
          // the actual metal gradient
          backgroundImage: chromeGradient,
          backgroundSize: "300% 100%",              // for the shiny animation
          // Essential: clip background into text & make the fill transparent
          WebkitBackgroundClip: "text",             // -webkit- prefix required in many browsers
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",       // Crucial! Without this Chrome will show solid color
          color: "transparent",

          // subtle stroked edge (reduce magenta intensity so it doesn't fill the glyph)
          WebkitTextStroke: "0.7px rgba(255,0,255,0.20)",

          // controlled neon glow — lower alpha so gradient is visible
          textShadow: `
            0 0 6px rgba(255,0,255,0.6),
            0 0 12px rgba(255,0,255,0.4),
            0 0 24px rgba(255,0,255,0.3)
          `,

          // optional moving shine effect; comment out animation if you don't want it
          animation: "ups-shine 3.5s linear infinite",
        }}
      >
        {mainText}
      </h1>

      

      <h2
        className="font-alex text-6xl"
        style={{
          textShadow:
            "0 0 5px rgba(255,255,255,0.9), 0 0 12px rgba(208,0,255,0.45), 0 0 22px rgba(106,0,255,0.35)",
          color: "rgba(255,240,255,0.95)",
        }}
      >
        {subText}
      </h2>
    </div>
  );
};

export default SynthwaveHeading;
